/* Sheet separation: --ink scrim at 40 % plus a --line border, no shadow (DECISIONS 2026-09-23) */
.scrim {
  position: fixed;
  inset: 0;
  z-index: 20;
  background: var(--scrim);
}

.sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 21;
  display: flex;
  flex-direction: column;
  max-height: 85dvh;
  margin: 0 auto;
  max-width: 600px;
  background: var(--panel);
  color: var(--ink);
  border: 1px solid var(--line);
  border-bottom: 0;
  border-radius: var(--r-sheet) var(--r-sheet) 0 0;
  outline: none;
}

.head {
  flex: none;
  padding: 0 var(--gutter);
  touch-action: none;
}

.handle {
  display: block;
  width: 40px;
  height: 4px;
  margin: var(--s2) auto var(--s1);
  border-radius: 2px;
  background: var(--ink2);
  opacity: 0.5;
}

.titleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
}

.body {
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0 var(--gutter) calc(var(--s5) + env(safe-area-inset-bottom));
}

@media (prefers-reduced-motion: no-preference) {
  .sheet {
    animation: slide-up 200ms ease-out;
  }

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }

    to {
      transform: translateY(0);
    }
  }
}
